import React from 'react';

// Ga PA rune, traced from its game picture into a two-tone icon in the MUI
// "TwoTone" manner: the slab's sides dimmed, its top faces solid, the three
// stars cut through both. 24-unit box; colour from `currentColor`.

const SIDE_OPACITY = 0.4;
const STAR_INNER_RATIO = 0.42;
const STAR_RADIUS = 1.45;

/** A five-pointed star centred on (cx, cy), point up. */
const starPath = (cx, cy, r) => {
    const points = Array.from({ length: 10 }, (_, i) => {
        const radius = i % 2 === 0 ? r : r * STAR_INNER_RATIO;
        const angle = -Math.PI / 2 + (i * Math.PI) / 5;
        return `${(cx + radius * Math.cos(angle)).toFixed(2)} ${(cy + radius * Math.sin(angle)).toFixed(2)}`;
    });
    return `M${points.join('L')}Z`;
};

const SILHOUETTE = 'M17.1 4L18.6 4.8L18.9 7L21.5 6.9L22.8 8.2L22.8 13.5L20.2 17.8L17.7 18L17.6 19.5L12.4 20.1L11.1 18.4L11.1 17L7.4 15.1L2.8 14.2L3 10.8L1 10L1.4 7.3L4 6.8L6.5 7.6L9 6.6L10.6 7.1L11.9 6.5L14.8 6.5L15.1 4.8Z';
const FACES = [
    // The slab's top, with the crack on its right.
    'M15.5 6.8L21.5 7.4L22.2 8.1L21.8 10.2L17.8 9.9L21.3 10.7L18.8 13.8L17.5 14L16.6 12.7L10.8 12.6L7.3 10.8L3.5 10.4L3.9 8.9L9.1 7L9.9 7.3L9.2 8.1L12.1 6.8Z',
    // The three studs' tops: back right, left, front.
    'M17 4.5L18 5.1L15.6 5.3L15.6 6.2L16.3 6.4L15.4 6.4L15.4 5.2Z',
    'M3.4 7.2L5.6 7.6L3.3 8.5L1.9 7.8L1.7 9.1L1.6 7.8Z',
    'M11.8 14.2L15.9 14.3L16.8 15.7L13.2 16.2L12 14.6L11.7 15Z',
].join('');
const STARS = starPath(11.6, 9.1, STAR_RADIUS) + starPath(15.4, 8.5, STAR_RADIUS) + starPath(14.3, 11.1, STAR_RADIUS);

const FmIcon = ({ className, size = '1.5rem' }) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
        focusable="false"
    >
        <path fillRule="evenodd" opacity={SIDE_OPACITY} d={SILHOUETTE + STARS} />
        <path fillRule="evenodd" d={FACES + STARS} />
    </svg>
);

export default FmIcon;
